// loaders.gl parse() often returns an ImageBitmap (no direct pixel access) - canvas round-trip if so.
export function toImageData(source: ImageBitmap | ImageData): ImageData {
    if (source instanceof ImageData) return source

    const canvas = document.createElement("canvas")
    canvas.width = source.width
    canvas.height = source.height
    const ctx = canvas.getContext("2d")
    if (!ctx) throw new Error("Failed to get 2d canvas context")
    ctx.drawImage(source, 0, 0)
    return ctx.getImageData(0, 0, source.width, source.height)
}
